import { jsx } from 'react/jsx-runtime';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleLoginButton } from './components/google-login-button/google-login-button.js';

function GoogleLogin({
  clientId,
  onSuccess,
  onFailure,
  iconOnly
}) {
  function handleSuccess(args) {
    onSuccess(args);
  }
  function handleError(args) {
    onFailure?.(args);
  }
  function handleNonAuthError(args) {
    onFailure?.(args);
  }
  return jsx(GoogleOAuthProvider, {
    clientId: clientId,
    children: jsx(GoogleLoginButton, {
      onError: handleError,
      onNonOAuthError: handleNonAuthError,
      onSuccess: handleSuccess,
      iconOnly: iconOnly
    })
  });
}

export { GoogleLogin };
